import { useState, useEffect } from 'react';
import { getCookie } from '@/lib/cookies';

export function useSmartBannerScroll() {
  const [smartbannerExited, setSmartbannerExited] = useState<boolean>(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    // Check the smartbanner-dismissed cookie value
    const checkSmartbannerCookie = () => {
      const cookieValue = getCookie('smartbanner-dismissed');
      setSmartbannerExited(cookieValue === 'true');
    };

    // Check on mount
    checkSmartbannerCookie();

    // Set up an interval to check for cookie changes (in case it's set elsewhere)
    const intervalId = setInterval(checkSmartbannerCookie, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > 100) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return { smartbannerExited, isScrolled };
}
